'use strict';

exports.VerificationType = void 0;
(function(VerificationType2) {
  VerificationType2["JsonWebKey2020"] = "JsonWebKey2020";
  VerificationType2["EcdsaSecp256k1VerificationKey2019"] = "EcdsaSecp256k1VerificationKey2019";
  VerificationType2["Ed25519VerificationKey2018"] = "Ed25519VerificationKey2018";
  VerificationType2["Bls12381G1Key2020"] = "Bls12381G1Key2020";
  VerificationType2["Bls12381G2Key2020"] = "Bls12381G2Key2020";
  VerificationType2["EcdsaSecp256k1RecoveryMethod2020"] = "EcdsaSecp256k1RecoveryMethod2020";
})(exports.VerificationType || (exports.VerificationType = {}));
const VerificationContext = {
  // https://w3c.github.io/vc-jws-2020/
  ["JsonWebKey2020"]: "https://w3id.org/security/suites/jws-2020/v1",
  // https://w3c-ccg.github.io/lds-ecdsa-secp256k1-2019/
  ["EcdsaSecp256k1VerificationKey2019"]: "https://w3id.org/security/v1",
  // https://w3c-ccg.github.io/lds-ed25519-2018/
  ["Ed25519VerificationKey2018"]: "https://w3id.org/security/v2",
  ["Bls12381G1Key2020"]: "https://w3id.org/security/suites/bls12381-2020/v1",
  ["Bls12381G2Key2020"]: "https://w3id.org/security/suites/bls12381-2020/v1",
  ["EcdsaSecp256k1RecoveryMethod2020"]: "https://w3id.org/security/suites/secp256k1recovery-2020/v2"
};

exports.VerificationContext = VerificationContext;
